const SCHEME_OR_PATH = /[/\\]|:\/\//;
const PORT_IN_HOST = /:\d+$/;
const IPV4_REGEX =
	/^((2(5[0-5]|[0-4][0-9])|[01]?[0-9]{1,2})\.){3}(2(5[0-5]|[0-4][0-9])|[01]?[0-9]{1,2})$/;
/** Loose IPv6 literal (incl. bracketed); colons-only shapes after scheme/port guards. */
const IPV6_REGEX =
	/^(\[)?(([0-9a-fA-F]{0,4}:){2,7}[0-9a-fA-F]{0,4}|::([0-9a-fA-F]{0,4}:){0,6}[0-9a-fA-F]{0,4}|([0-9a-fA-F]{0,4}:){1,7}:)(\])?$/i;

function isPlausibleHostname(value: string): boolean {
	if (value.length > 253) return false;
	const labels = value.split(".");
	if (labels.length < 1) return false;
	return labels.every((label) => {
		if (label.length < 1 || label.length > 63) return false;
		return /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(label);
	});
}

function isPlausibleIpv6(value: string): boolean {
	const raw = value.startsWith("[") && value.endsWith("]") ? value.slice(1, -1) : value;
	if (!raw.includes(":")) return false;
	return IPV6_REGEX.test(value.startsWith("[") ? value : raw);
}

/** Hostname or IP only (no port, scheme, or path). `label` is the field name shown in warnings. */
export function validateJhaNetworkServerName(
	value: string,
	label = "Host name"
): { valid: boolean; message: string } {
	const v = String(value ?? "").trim();
	if (!v) {
		return { valid: false, message: `${label} is required.` };
	}
	if (/\s/.test(v)) {
		return { valid: false, message: `Please enter a valid input. Spaces are not allowed in the ${label.toLowerCase()}.` };
	}
	if (SCHEME_OR_PATH.test(v) || /^[a-z][a-z0-9+.-]*:/i.test(v)) {
		return { valid: false, message: `${label} must not include a scheme or path.` };
	}
	if (PORT_IN_HOST.test(v)) {
		return { valid: false, message: `${label} must not include a port.` };
	}
	if (IPV4_REGEX.test(v) || isPlausibleIpv6(v) || isPlausibleHostname(v)) {
		return { valid: true, message: "" };
	}
	return {
		valid: false,
		message: `${label} must be a valid hostname or IP address.`,
	};
}
